module.exports = __webpack_public_path__ + "static/media/thum1.40d83e7a.jpg";